module.exports = __webpack_public_path__ + "img/logo.dff8328d.png";